// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import head from 'lodash/head';
import Icon from '../../components/shared/Icons/Icon';
import ImageSnippetModal from '../ImageSnippetModal';
import styles from './styles';
import messages from './messages';

type Props = {
  ad: Object,
  verticalName: VerticalName,
  onItemClicked: Function,
};

const MAX_DESCRIPTION_SIZE = 60;

export default function SnippetModal({ ad, verticalName, onItemClicked }: Props) {
  const verticalProperties = get(ad, 'verticalProperties', {});
  const price = verticalProperties.price;
  const images = verticalProperties.images;
  const redirectUrl = ad.redirectUrl;

  function getTitle(title) {
    if (typeof title !== 'string') {
      return '';
    }

    if (title.length < MAX_DESCRIPTION_SIZE) {
      return title;
    }

    const shortTitle = title.slice(0, MAX_DESCRIPTION_SIZE);
    return `${shortTitle.slice(0, shortTitle.lastIndexOf(' '))}...`;
  }

  return (
    <a href={redirectUrl} className="snippet-modal" onClick={onItemClicked}>
      <div className="img-wrapper">
        {images && images.length ? (
          <ImageSnippetModal image={head(images)} preferredSize={11} width={160} height={120} />
        ) : (
          <div className="icon-wrapper">
            <Icon width={50} type={verticalName} />
          </div>
        )}
      </div>

      <div className="text-wrapper">
        <h2> {getTitle(ad.title)}</h2>

        {price && price.value ? (
          <span className="currency"> {price.valueFormatted} </span>
        ) : (
          <span className="currency">
            <FormattedMessage {...messages.unavailablePrice} />
          </span>
        )}
      </div>
      <style jsx>{styles}</style>
    </a>
  );
}



// WEBPACK FOOTER //
// ./app/common/SnippetModal/index.js